"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _address = _interopRequireDefault(require("./address"));

var _poiType = _interopRequireDefault(require("./poi-type"));

require("./poi-data.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PoiData = function PoiData(_ref) {
  var poi = _ref.poi;
  var _poi$category = poi.category,
      category = _poi$category === void 0 ? {} : _poi$category,
      name = poi.name;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "tooltip-poi-data"
  }, /*#__PURE__*/_react["default"].createElement(_poiType["default"], {
    type: category.icon,
    categoryName: category.name,
    name: name
  }), /*#__PURE__*/_react["default"].createElement(_address["default"], poi));
};

var _default = PoiData;
exports["default"] = _default;
PoiData.propTypes = {
  poi: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    category: _propTypes["default"].shape({
      name: _propTypes["default"].string,
      icon: _propTypes["default"].string
    })
  })
};
PoiData.defaultProps = {
  poi: {}
};